import { useFeatureFlagCompat } from '@platform/core/feature-flags';

import type { FeatureFlagKey } from './feature-flags';

export const useFeatureFlag = useFeatureFlagCompat<FeatureFlagKey>;
